import { ExclamationCircleIcon } from '@heroicons/react/solid';

export function Input({ label, name, errorMessage, children }) {
  return (
    <>
      <label
        htmlFor={name}
        className={`block text-sm font-medium text-gray-700 ${
          errorMessage && 'has-error'
        }`}
      >
        {label}
      </label>
      <div className="mt-1 relative rounded-md shadow-sm">
        {children}
        {errorMessage && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      <p className={`mt-0 pt-0 text-sm text-red-600`} id={`${name}-error`}>
        {errorMessage}
      </p>
    </>
  );
}

export function TextBox({
  label,
  name,
  value,
  errorMessage,
  handleChange,
  ...props
}) {
  return (
    <Input label={label} errorMessage={errorMessage}>
      <input
        {...props}
        type="text"
        id={name}
        name={name}
        value={value || ''}
        autoComplete={name}
        onChange={handleChange}
        className="mt-1 focus:ring-purple-500 focus:border-purple-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
      />
    </Input>
  );
}

export function TextArea({ label, name, value, errorMessage, handleChange }) {
  return (
    <Input label={label} errorMessage={errorMessage}>
      <textarea
        rows={4}
        id={name}
        name={name}
        value={value || ''}
        autoComplete={name}
        onChange={handleChange}
        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
      />
    </Input>
  );
}

export function CheckBox({
  label,
  name,
  value,
  errorMessage,
  handleChange,
  ...props
}) {
  return (
    <>
      <div
        className={`relative flex items-start  ${errorMessage && 'has-error'}`}
      >
        <div className="flex items-center h-5">
          <input
            {...props}
            id={name}
            type="checkbox"
            name={name}
            checked={value}
            className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300 rounded"
            onChange={handleChange}
          />
        </div>
        <div className="ml-3 text-sm">
          <label
            htmlFor={name}
            className="text-gray-700"
            dangerouslySetInnerHTML={{ __html: label }}
          ></label>
        </div>
      </div>
      <p className={`mt-0 pt-0 text-sm text-red-600`} id={`${name}-error`}>
        {errorMessage}
      </p>
    </>
  );
}
